export default __webpack_public_path__ + "static/gform-hero-img-002f1b9a27b852be13888607027c2974.png";